<template>
  <div
    class="cmnotice"
    :class="{
      isiOSX: isiOSX,
      isPreview: isApp != 1,
    }"
  >
    <van-nav-bar
      v-if="isApp == 1"
      class="cmnotice-title"
      :fixed="true"
      title="销巴公告"
      @click-right="toShare()"
    >
      <template #right>
        <img src="../../../assets/cms/share.png" v-if="isToken" width="24px" />
      </template>
    </van-nav-bar>
    <img
      v-if="entranceChannel == 2 && isApp == 1"
      @click="goBack()"
      class="cmnotice-reback"
      src="../../../assets/myInvest/reback.png"
    />
    <img
      v-if="entranceChannel == 1 && isApp == 1"
      @click="prev()"
      class="cmnotice-reback"
      src="../../../assets/myInvest/reback.png"
    />
    <div class="cmnotice-content">
      <div class="tip" v-if="data.is_end">
        <img src="../../../assets/cms/tip.png" />
        <p>请注意，该条公告为过期公告。</p>
      </div>
      <div class="contentDiv" :class="{ tipContent: data.is_end }">
        <p class="title">{{ data.title }}</p>
        <p class="time">{{ data.start_time }}</p>
        <div id="content" v-html="data.content" v-imageLoad="loadImg"></div>
      </div>
    </div>
    <van-popup
      v-model="showDownload"
      position="bottom"
      :style="{ backgroundColor: 'rgba(0,0,0,0)' }"
    >
      <div class="popupContent">
        <ul class="phone">
          <li @click="download()">保存图片</li>
        </ul>
        <div class="btn" @click="close">取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import imageLoad from "vue-images-loaded";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      data: {},
      isiOSX: false,
      isiOS: false,
      id: "",
      entranceChannel: 1, //1返回上一页2返回app上一页,3预览
      isToken: false,
      isApp: 2, //1是app2不是app
      imageUrl: [],
      showDownload: false,
      downloadUrl: "",
      shareImg: "",
    };
  },
  directives: {
    imageLoad,
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created() {
    this.isiOSX = this.isIphoneX();
    let u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (this.$route.query.token && this.$route.query.token != '') {
      this.isToken = true;
      this.$api.setToken(this.$route.query.token);
    }
    if (this.$route.query.entranceChannel) {
      this.entranceChannel = this.$route.query.entranceChannel;
    }
    this.id = this.$route.query.id;
    if (this.$route.query.isApp) {
      this.isApp = this.$route.query.isApp;
    }
  },
  methods: {
    getAggrement() {
      if (this.entranceChannel == 3) {
        this.$api
          .get("cms-v2/index/preview/detail", {
            class: "Notice",
            temp_id: this.$route.query.temp_id,
          })
          .then((res) => {
            this.data = res;
          });
      } else {
        if (this.isToken) {
          this.$api
            .get("cms-v2/member/notice/detail", { id: this.id, client: 1 })
            .then((res) => {
              this.data = res;
              this.data.content = this.data.content.replace(
                /isApp=3/g,
                `isApp=${this.isApp}`
              );
            });
        } else {
          this.$api
            .get("cms-v2/index/notice/app/detail", { id: this.id })
            .then((res) => {
              this.data = res;
              this.data.content = this.data.content.replace(
                /isApp=3/g,
                `isApp=${this.isApp}`
              );
            });
        }
      }
    },
    contentText(value) {
      let result = "";
      let flag = false;
      for (let char of value) {
        if (char === ">") {
          flag = true;
        }
        if (char === "<") {
          flag = false;
        }
        if (flag && char !== ">") {
          result = result + char;
        }
      }
      return result;
    },
    goBack() {
      this.params("", "", "goBack");
    },
    prev() {
      this.$router.go(-1);
    },
    // 获取分享图标
    getShareImg() {
      this.$api.get("cms-v2/index/share/logo").then((res) => {
        this.shareImg = res.src;
      });
    },
    toShare() {
      // 分享
      var title = this.contentText(this.data.content);
      var bigTitle = this.data.title;
      var thumb = this.shareImg;
      let url = location.href.split("?")[0] + "?id=" + this.$route.query.id;
      var paramAndroid = [bigTitle, title, url, thumb];
      var paramIos = [title, bigTitle, url, thumb];
      this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
    },
    // 图片操作
    loadImg() {
      let timer = "";
      let isLongTouch = false; // 加个标志位，防止settimeout因为事件循环和实际时间有偏差
      let _this = this;
      let move;
      let content = document.getElementById("content");
      //获取v-html中的所有img标签，返回一个类数组
      let img = content.getElementsByTagName("img");
      //将类数组转换为数组
      img = Array.from(img);
      //遍历数组添加点击事件
      img.forEach((element, index) => {
        _this.imageUrl.push(element.src);
        // 长按下载
        element.addEventListener("touchstart", function (e) {
          move = false;
          timer = setTimeout(function () {
            isLongTouch = true;
            move = true;
            // 长按
            if (!_this.isiOS) {
              _this.showDownload = true;
              _this.downloadUrl = element.src;
            }
          }, 700);
        });

        element.addEventListener("touchend", function () {
          clearTimeout(timer);
          if (move) {
            // 滑动
            isLongTouch = false; // 重置标志位
          } else {
            // 点击
            ImagePreview({ images: _this.imageUrl, startPosition: index });
          }
        });
        element.addEventListener("touchmove", function () {
          clearTimeout(timer);
          move = true;
        });
      });
    },
    // 下载图片
    download() {
      let _this = this;
      const image = new Image();
      // 解决跨域 canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        //得到图片的base64编码数据
        const url = canvas.toDataURL("image/png");
        if (_this.isApp == 1) {
          _this.params(url, url, "preservation");
        } else {
          // 生成一个 a 标签
          // const a = document.createElement("a");
          // // 创建一个点击事件
          // const event = new MouseEvent("click");
          // // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
          // a.download = name || "图片";
          // // 将生成的 URL 设置为 a.href 属性
          // a.href = url;
          // // 触发 a 的点击事件
          // a.dispatchEvent(event);
        }
        this.showDownload = false;
      };
      image.src = this.downloadUrl;
    },
    // 取消下载
    close() {
      this.showDownload = false;
    },
  },
  mounted() {
    this.getAggrement();
    this.getShareImg();
  },
};
</script>

<style lang="less">
body {
  min-height: 100%;
  height: auto;
  background: #f5f6f7;
  .van-nav-bar__title {
    font-size: 18px !important;
    font-weight: normal !important;
  }
  .cmnotice {
    height: 100%;
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 27px;
      left: 0;
      z-index: 1;
    }
    &-content {
      padding-top: 68px;
      box-sizing: border-box;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .tip {
        position: fixed;
        width: 100%;
        height: 44px;
        background-color: rgba(255, 229, 219, 0.8);
        display: flex;
        align-items: center;
        padding: 0 16px;
        img {
          width: 16px;
          height: 16px;
        }
        p {
          margin-left: 6px;
          font-size: 14px;
          color: #ff5619;
        }
      }
      .tipContent {
        margin-top: 56px;
      }
      .contentDiv {
        padding: 0 16px 16px;
        .title {
          color: #333333;
          font-size: 19px;
          font-weight: bolder;
          margin-top: 12px;
        }
        .time {
          color: #999999;
          font-size: 13px;
          margin: 12px 0 16px 0;
        }
        img {
          width: 100% !important;
          display: block;
          height: auto !important;
        }
        a {
          color: #ff5619 !important;
        }
        p {
          word-break: break-word;
          text-align: justify !important;
          font-size: 16px;
          line-height: 24px;
        }
        .ql-align-center {
          text-align: center !important;
        }
        .ql-align-right {
          text-align: right !important;
        }
        ol {
          list-style: decimal;
          margin-left: 20px;
          font-size: 16px;
          line-height: 24px;
        }
        ul {
          list-style: disc;
          margin-left: 20px;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
    .popupContent {
      margin: 0 12px;
      text-align: center;
      font-size: 18px;
      color: #333;
      .phone {
        border-radius: 12px;
        background-color: #ffffff;
        padding: 0 16px;
        li {
          height: 57px;
          line-height: 57px;
          color: #333;
        }
      }
      .btn {
        border-radius: 12px;
        background-color: #ffffff;
        height: 49px;
        line-height: 49px;
        margin-top: 10px;
        margin-bottom: 34px;
      }
    }
  }
  .isiOSX {
    .cmnotice {
      &-title {
        padding-top: 44px;
      }
      &-reback {
        top: 45px;
      }
      &-content {
        padding-top: 88px;
      }
    }
  }
  .isPreview {
    .cmnotice {
      &-content {
        padding-top: 0px;
      }
    }
  }
}
</style>
